import { makeStyles } from "@material-ui/core";

export const useClassnames = makeStyles((theme) => ({
  complete: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.getContrastText(theme.palette.success.dark),
    "&:focus": {
      backgroundColor: theme.palette.success.main,
    },
    "&:hover": {
      backgroundColor: theme.palette.success.dark,
    },
  },
  incomplete: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.getContrastText(theme.palette.error.dark),
    "&:focus": {
      backgroundColor: theme.palette.error.main,
    },
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));
